import React, { useState } from "react";
import { Button, Modal } from "antd";
import { toast } from "react-toastify";
import { nonNumericRegex } from "../../hooks/helper";
import { storeEvent, storeTestimonials } from "../../Libs/api";

const AddEvent = ({ singleData, openModal, onClose, onSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState({
    title: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputData?.title) {
      toast.error("Please Enter a title");
    } else {
      setLoading(true);
      let formData = {
        title: inputData?.title,
      };
      try {
        const apiCall = await storeEvent(formData);
        if (apiCall.status) {
          console.log(apiCall, "apiCall");

          setLoading(false);
          toast.success("Record Added Successfully!");
          onSubmit();
        } else {
          setLoading(false);

          toast.error(apiCall?.message);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
        toast.error(error);
      }
    }
  };

  return (
    <Modal
      title={
        <div
          style={{
            background: "#006666",
            color: "#fff",
            padding: "12px",
            borderRadius: "4px",
          }}
        >
          Add Event
        </div>
      }
      centered
      open={openModal}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={[
        <Button
          key="ok"
          type="primary"
          style={{ background: "#006666", color: "white" }}
          disabled={loading}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          Add Event
        </Button>,
      ]}
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center mt-3 mb-3">
                <svg className="custom-loader" viewBox="25 25 50 50">
                  <circle
                    className="custom-loader-circle"
                    r="20"
                    cy="50"
                    cx="50"
                  ></circle>
                </svg>
              </div>
            ) : (
              <div class="row mt-3">
                <div class="col-sm-12 col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Title</label>
                    <input
                      class={`form-control`}
                      type="text"
                      placeholder="Enter Title.."
                      value={inputData?.title}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          title: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddEvent;
